import React, { Component } from 'react';
import { connect } from 'react-redux';

import Layout from '../../components/layout';
import Loading from '../../components/spinner';
import { NormalText, SmallText, Spacer, StrongText, Subtitle, Title } from '../../components/common';
import { withTranslation } from '../../lib/translate';

import './index.css';
import { forwardTo, getGiftCardNumber, getMaskedGiftCardNumber } from '../../lib/utils';
import { QRCodeCanvas } from 'qrcode.react';
import Basket from '../../lib/basket';
import moment from 'moment';

class GiftCard extends Component {
    componentDidMount() {
        if (!this.props.location?.state?.card) {
            forwardTo('/loyalty')
        }
    }

    render() {
        const { __ } = this.props;
        const card = this.props.location?.state?.card
        const isExpired = this.props.location?.state?.isExpired
        const expiresToday = this.props.location?.state?.expiresToday
        const title = `${__(card?.is_topup_card ? 'Top Up card' : card?.is_event_card ? 'Event card' : 'Gift card')} ${getMaskedGiftCardNumber(card)}`
        const expiryMoment = moment(card?.expiry_date, 'DD/MM/YYYY')
        const expiryDate = expiryMoment.format('LLLL')
        const history = [...(card?.history || [])].sort((a, b) => moment(b.timestamp) - moment(a.timestamp))
        return (
            <Loading>
                <Layout headerWithTitle color="transparent" title={title}>
                    <div className='absolute-content scrollable-y'>
                        <Title className='web-only page-title-centered'>{title}</Title>
                        <div className='gift-card-qr-wrapper'>
                            <div className='gift-card-qr'>
                                <QRCodeCanvas value={card?.qr_code} size={150} />
                            </div>
                            <StrongText className='gift-card-number'>{getGiftCardNumber(card)}</StrongText>
                            <SmallText className='text-to-update'>{__('Scan at the counter to pay')}</SmallText>
                        </div>
                        <Spacer size={2} />
                        <div className='box-content flex-wrapper flex-justify-between flex-align-center'>
                            <div>
                                <StrongText className='block text-to-update'>{__('Balance')}</StrongText>
                                {expiryMoment.isValid() && (
                                    <SmallText className={`block${isExpired || expiresToday ? ' danger-color' : ''}`}>
                                        {expiresToday ? __('Expires today') : `${__(isExpired ? 'Expired' : 'Expires')} ${expiryDate}`}
                                    </SmallText>
                                )}
                            </div>
                            <StrongText>{Basket.formatPrice(card?.value_remaining / 100, true)}</StrongText>
                        </div>
                        {history.length > 0 && (
                            <>
                                <Spacer size={5} />
                                <StrongText className='block text-to-update'>{__('Transactions')}</StrongText>
                                <Spacer size={2} />
                                <div className='box-wrapper box-wrapper-list'>
                                    {history.map((el, index) => {
                                        const isCredit = el.type == 'value_added' || el.type == 'value_refunded'
                                        return (
                                            <div key={`card_${index}`} className='flex-wrapper flex-justify-between flex-align-center'>
                                                <div>
                                                    <StrongText className='block text-to-update'>{el.type == 'value_added' ? __('Value added') : el.type == 'value_refunded' ? __('Value refunded') : __('Value spent')}</StrongText>
                                                    <SmallText className='block'>{moment(el.timestamp).format('LLLL h:mm a')}</SmallText>
                                                </div>
                                                <StrongText >
                                                    {`${isCredit ? '+' : '-'}${Basket.formatPrice(el.value / 100, true)}`}
                                                </StrongText>
                                            </div>
                                        )
                                    })}
                                </div>
                            </>
                        )}
                    </div>
                </Layout>
            </Loading>
        );
    }
}

const stateToProps = (state) => {
    return {
    };
};

export default connect(stateToProps)(withTranslation(GiftCard));
